import { render } from "./InnerLoader.vue?vue&type=template&id=427be07e&scoped=true"
import script from "./InnerLoader.vue?vue&type=script&lang=js"
export * from "./InnerLoader.vue?vue&type=script&lang=js"

import "./InnerLoader.vue?vue&type=style&index=0&id=427be07e&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427be07e"]])

export default __exports__